import React, { useEffect, useState } from "react";

import { t } from "i18next";

import { Box, Typography, useMediaQuery } from "@mui/material";

import { theme } from "@/src/theme/theme";

import {
  CONSUMER_HOMEPAGE_PREFIX,
  HOMEPAGE_CONTAINER_STYLES
} from "@/src/pages/consumer/HomePage/HomePageContent";

import { VehicleType } from "@/src/types/types";
import {
  DealerLogo,
  DealerLogoData,
  getDealerLogoData,
  getLogoUrl,
  getPadding
} from "@/src/utils/dealerLogoUtils";

interface LogosProps {
  category: "primary" | "secondary";
  logos: DealerLogo[];
  isMobile: boolean;
}

interface DealerLogosProps {
  vehicleType: VehicleType;
}

const Logos = (props: LogosProps) => {
  const { category, logos, isMobile } = props;
  const defaultLogoSize = isMobile ? "60px" : "100px";

  return logos.map((logo) => {
    return (
      <Box
        component="img"
        key={`logo-${logo.fileName}`}
        src={getLogoUrl(category, logo.fileName)}
        alt={logo.alt}
        sx={{
          width: defaultLogoSize,
          height: defaultLogoSize,
          mr: isMobile ? 1 : 3,
          p: getPadding(isMobile, logo.hasCustomPadding),
          backgroundColor: theme.palette.background.paper
        }}
      />
    );
  });
};

const DealerLogos = ({ vehicleType }: DealerLogosProps) => {
  const [dealerLogos, setDealerLogos] = useState<DealerLogoData>({
    primary: [],
    secondary: []
  });
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = (await getDealerLogoData()) as DealerLogoData;
        setDealerLogos(data);
      } catch (error) {
        console.error("Error fetching dealer logos:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <Box sx={{ ...HOMEPAGE_CONTAINER_STYLES }}>
      <Typography variant="h2" sx={{ pb: 0 }}>
        {t(`${CONSUMER_HOMEPAGE_PREFIX}.${vehicleType}.dealerLogoTitle`)}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center"
        }}
      >
        <Logos
          logos={dealerLogos.primary.sort(() => Math.random() - 0.5)}
          category="primary"
          isMobile={isMobile}
        />
        <Logos
          logos={dealerLogos.secondary.sort(() => Math.random() - 0.5)}
          category="secondary"
          isMobile={isMobile}
        />
      </Box>
    </Box>
  );
};

export default DealerLogos;
